import React, { useContext, useEffect, useState } from 'react';

import { useHistory, Link } from 'react-router-dom';

import MUIDataTable from "mui-datatables";
import { Box, Grid, Tooltip, Typography } from '@mui/material';
import { Chip } from '@mui/material';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faEdit, faPlay, faTrash } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '@mui/material';
import UserContext from '../../../navigation/context/userContext';
import { GetProductos } from '../../../controllers/company/ProductsController';
import CompanyRoutes from '../../../apiRoutes/CompanyRoutes';
import { imagesURL } from '../../../apiRoutes/apiBase';
import { POST } from '../../../controllers/ConsumeApiController';

//export default class TablaProductos extends Component
export default function ProductsDataTable({products, onChangeStatus})
{
    const {userData,setUserData} = useContext(UserContext)
    //const [products,setProductos] = useState([]);

    /*useEffect( () => {
        getProductos()
    },[])*/

    const columns = [
        /*{
            name : '',
            label : 'Imagen',
            options : 
            {
                customBodyRenderLite : (dataIndex) => {
                    //let id = subCategorias[dataIndex].idSubCategoria;
                    return(
                        <div>
                           <img style={{width:100,height:100}} src={imagesURL + 'products/' + products[dataIndex].imagen}/>
                        </div>
                    );
                },
                filter:false
            }
        },*/
        {
            name : 'image',
            label : 'Producto',
            options : 
            {
                customBodyRenderLite : (dataIndex) => {
                    //let id = subCategorias[dataIndex].idSubCategoria;
                    return(
                        <Box sx={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                            <img style={{width:100,height:100,borderRadius:10}} src={imagesURL + 'productos/' + products[dataIndex].image}/>
                        </Box>
                    );
                },
                filter:false,
                searchable:true
            }
        },
        {
            name : 'name',
            label : 'Nombre',
            options:
            {
                filter: false
            }
        },
        {
            name : 'category',
            label : 'Categoría',
        },
        {
            name : 'unit_symbol',
            label : 'Unidad',
        },
        {
            name : 'has_variants',
            label : 'Variaciones',
            options : 
            {
                customBodyRender : (value, tableMeta, updateValue) => (
                    value === true
                    ? <Typography>SI</Typography>
                    : <Typography>NO</Typography>
                )            
            }
        },
        {
            name : 'display_price',
            label : 'Precio',
            
            options:{
                filter:false
            }
        },
        {
            name : 'category',
            label : 'Categoria',
            options:{
                filter:true,
                //filterType:'dropdown',
                display:false,
                searchable:true
            }
        },
        {
            name : 'status',
            label : 'Estatus',
            options : 
            {
                customBodyRender : (value, tableMeta, updateValue) => (
                    value === 1
                    ? <Chip label='Activo' color='success'/>
                    : <Chip label='Inactivo' color='error' />
                )            
            }
        },
        {
            name : '',
            label : 'Acciones',
            options : 
            {
                customBodyRenderLite : (dataIndex) => {
                    //let id = subCategorias[dataIndex].idSubCategoria;
                    return(
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
                            <Link 
                                onClick = { () => onChangeStatus(products[dataIndex].id)  }  
                            >
                                <IconButton>
                                {
                                    products[dataIndex].status === 1
                                    ? <FontAwesomeIcon icon={faTrash}/>
                                    : <FontAwesomeIcon icon={faPlay}/>
                                }
                                </IconButton>
                            </Link>

                            
                            <Link 
                                to={`/products/edit/${products[dataIndex].id}`}
                                //onClick={ ()=> localStorage.setItem('producto',JSON.stringify(products[dataIndex])) }
                                replace
                            >
                                <IconButton>
                                    <FontAwesomeIcon icon={faEdit}/>
                                </IconButton>
                            </Link>

                            <Tooltip title='Copiar enlace'>
                                <IconButton>
                                    <FontAwesomeIcon icon={faCopy}/>
                                </IconButton>
                            </Tooltip>
                        </div>
                    );
                },

                filter:false,
                print:false
            }
        }
    ];




    /*const getProductos = async () => {
        let response = await GetProductos(userData.entity.uuid);
        if(response.success === true)
        {
            setProductos(response.data.products);
        }
    }*/


    const options = {
        filterType: 'checkbox',
        selectableRows: 'none',
        scrollX: true, // Habilita el scroll horizontal en mui-datatables
        elevation: 2
    };


    return(
        <MUIDataTable
        
            responsive={true}
            title={"Listado de Productos"}
            data={products}
            columns={columns}
            options={options}
        />
    )
}